import { Box, VStack, Link, Tooltip, IconButton, useMediaQuery } from '@chakra-ui/react';
import { FaHome, FaUser, FaProjectDiagram, FaGraduationCap, FaFileAlt, FaCertificate, FaEnvelope } from 'react-icons/fa';

const Sidebar = () => {
    const color = 'gray.700';
    const [isMobile] = useMediaQuery("(max-width: 768px)") 
    return (
        <Box display={isMobile ? 'none':'block'} as="nav" position="fixed" top="0" left="0" width="220px" height="100vh" p={4}>
            <VStack align="start" spacing={6}>
                <Tooltip label="Home" aria-label="Home Tooltip">
                    <Link href="#" fontSize="lg" color={color} fontWeight="bold">
                        <IconButton isRound size="lg" icon={<FaHome />}/>
                    </Link>
                </Tooltip>
                <Tooltip label="About Me" aria-label="About Me Tooltip">
                    <Link href="#about" fontSize="lg" color={color} fontWeight="bold">
                        <IconButton icon={<FaUser />}  isRound size="lg" />
                    </Link>
                </Tooltip>
                <Tooltip label="Education" aria-label="Education Tooltip">
                    <Link href="#education" fontSize="lg" color={color} fontWeight="bold">
                        <IconButton icon={<FaGraduationCap />}  isRound size="lg" />
                    </Link>
                </Tooltip>
                <Tooltip label="Projects" aria-label="Projects Tooltip">
                    <Link href="#projects" fontSize="lg" color={color} fontWeight="bold">
                        <IconButton icon={<FaProjectDiagram />}  isRound size="lg" />
                    </Link>
                </Tooltip>
                <Tooltip label="Resume" aria-label="Resume Tooltip">
                    <Link href="#resume" fontSize="lg" color={color} fontWeight="bold">
                        <IconButton icon={<FaFileAlt />}  isRound size="lg" />
                    </Link>
                </Tooltip>
                <Tooltip label="Certifications" aria-label="Certifications Tooltip">
                    <Link href="#certifications" fontSize="lg" color={color} fontWeight="bold">
                        <IconButton icon={<FaCertificate />}  isRound size="lg" />
                    </Link>
                </Tooltip>
                <Tooltip label="Contact" aria-label="Contact Us Tooltip">
                    <Link href="#contact" fontSize="lg" color={color} fontWeight="bold">
                        <IconButton icon={<FaEnvelope />}  isRound size="lg" />
                    </Link>
                </Tooltip>
            </VStack>
        </Box>
    );
};

export default Sidebar;
